// extracted by mini-css-extract-plugin
export default {"title":"title_title__QV6Mf","title__wing":"title_title__wing__cekj3"};